<template>
  <!-- Progress bars -->
  <div v-if="!readonly">
    <div class="row">
      <div class="col">
        <label for="width-range" class="form-label mb-0">{{ $t('components.order-form.width') }}</label>
        <el-slider
          id="width-range"
          v-model="order.calfCircumferenceWithoutDeduction"
          show-input
          :precision="0"
          :min="0"
          :max="20000"
          :step="1"
          :show-tooltip="false"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="height-range" class="form-label mb-0">{{ $t('components.order-form.height') }}</label>
        <el-slider
          v-model="order.heightWithoutDeduction"
          show-input
          :precision="0"
          :min="0"
          :max="20000"
          :step="1"
          :show-tooltip="false"
          if="height-range"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="length-range" class="form-label mb-0">{{ $t('components.order-form.depth') }}</label>
        <el-slider id="length-range" v-model="order.depth" show-input :precision="0" :min="0" :max="20000" :step="1" :show-tooltip="false" />
      </div>
    </div>
  </div>
  <div v-else>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary mb-1">{{ $t('components.order-form.width') }}</label>
      <label class="col-sm-6 form-label mb-1">{{ order.calfCircumferenceWithoutDeduction }}</label>
    </div>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary mb-1">{{ $t('components.order-form.height') }}</label>
      <label class="col-sm-6 form-label mb-1">{{ order.heightWithoutDeduction }}</label>
    </div>
    <div class="row1">
      <label class="col-sm-6 form-label text-secondary mb-1">{{ $t('components.order-form.depth') }}</label>
      <label class="col-sm-6 form-label mb-1">{{ order.depth }}</label>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import { OrderData } from '@/views/ConfiguratorPage.vue';

@Component({
  components: {},
})
@Component
export default class ProductParamterCuboid extends Vue {
  @Prop() order!: OrderData;
  @Prop({ default: false }) readonly!: boolean;
}
</script>

<style scoped lang="scss">
.text-secondary {
  color: #0000008d !important;
  text-align: left !important;
}

.row1 {
  border-bottom: 0.1rem solid #6767678d;
}

.form-label {
  font-size: 1rem;
  margin: 0.7rem 0 0.5rem 0;
  text-align: right;
}
</style>
